import { render, staticRenderFns } from "./RecieptForm.vue?vue&type=template&id=3a4d56aa&"
import script from "./RecieptForm.vue?vue&type=script&lang=js&"
export * from "./RecieptForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports